import React, { PropTypes } from 'react';
import { Field } from 'redux-form';

const ReferralFormCheckboxGroup = (props) => {
  const { input, name, label, requiredLabel, isRequired, options, meta: { touched, dirty, error } }  = props;
  const hasError = (dirty || touched) && error;

  return (
    <div>
      <label>
        {label}
        {isRequired && <span className="required">{` * (${requiredLabel})`}</span>}
      </label>
      <div className="small-fields small-checkboxes">
        {options.map(o => (
          <div className="option-small" key={o.name}>
            <div className="checkbox-outer">
              <Field
                className={hasError ? 'is-invalid-input' : ''}
                name={`${name}.${o.name}`}
                id={`${o.name}`}
                checked={input.value[o.name]}
                component="input"
                type="checkbox"
              />
              <label htmlFor={`${o.name}`}>
                {o.title}
              </label>
            </div>
          </div>
        ))}
      </div>
      {hasError && <span className="form-error is-visible">{error}</span>}
    </div>
  );
};

ReferralFormCheckboxGroup.propTypes = {
  input: PropTypes.object,
  name: PropTypes.string,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  requiredLabel: PropTypes.string,
  options: PropTypes.array,
  meta: PropTypes.object
};

export default ReferralFormCheckboxGroup;




/** WEBPACK FOOTER **
 ** ./src/members/Main/Referral/ReferralForm/ReferralFormCheckboxGroup/index.js
 **/